import { DELETE_FILE_SUCCESS } from 'constants/documents';
import {
  FETCH_DOCUMENTS_COLLECTIONS_SUCCESS,
  FETCH_TRACKING_PAGE_SUCCESS,
} from 'constants/payment';
import type { DocumentsCollection } from 'models/documentsCollection';

type DocumentsCollectionAction =
  | {
      type:
        | typeof FETCH_TRACKING_PAGE_SUCCESS
        | typeof FETCH_DOCUMENTS_COLLECTIONS_SUCCESS;
      payload: {
        documentsCollections: DocumentsCollection;
      };
    }
  | {
      type: typeof DELETE_FILE_SUCCESS;
      payload: {
        fileId: string;
      };
    };

const documentsCollection = (
  state: DocumentsCollection | Record<string, never> = {},
  action: DocumentsCollectionAction,
) => {
  switch (action.type) {
    case FETCH_TRACKING_PAGE_SUCCESS:
    case FETCH_DOCUMENTS_COLLECTIONS_SUCCESS:
      const { documentsCollections } = action.payload;

      return { ...documentsCollections };
    case DELETE_FILE_SUCCESS:
      const { fileId } = action.payload;
      const { documents } = state;

      if (!documents) {
        return state;
      }

      const newDocuments = documents.map(document => {
        const { files } = document;

        document.files = files.filter(file => file.id !== fileId);

        return document;
      });

      return { ...state, documents: newDocuments };
    default:
      return state;
  }
};

export { documentsCollection };
